module.exports = __webpack_public_path__ + "static/media/3-2.67827851.mp3";